import { useContext } from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import SharedAntdTable from '../../common/shared-antd-table/SharedAntdTable';
import sharedRouterLinks from '../../components/app/shared-routes/sharedRouterLinks';
import UserContext from '../../contexts/user-context/UserProvider';
import WebsitePackagesTableColumns from './WebsitePackagesTableColumns';
import queryString from 'query-string';
import {
  setConfirmModal,
  setDeleteModalOpened,
  setSelectedTableRow,
  setWebsitePackageFormOpenedAction
} from '../../redux/website-packages-slice/websitePackagesSlice';

const WebsitePackagesPageTable = () => {
  const { search } = useLocation();
  const values = queryString.parse(search);
  const { i18n } = useTranslation();
  const { user } = useContext(UserContext);
  const dispatch = useDispatch();
  const fetchedTableData = useSelector(
    (store) => store.websitePackages.fetchedTableData
  );
  const fetchDataCount = useSelector(
    (store) => store.websitePackages.fetchDataCount
  );
  const deleteModalOpened = useSelector(
    (store) => store.websitePackages.deleteModalOpened
  );
  const isLoadingTableData = useSelector(
    (store) => store.websitePackages.isLoadingTableData
  );
  // map all data to dataSource
  const [tableDataSource, setTableDataSource] = useState([]);
  const mapDataSource = (data) => {
    return data.map((obj, index) => ({
      ...obj,
      key: obj.id
    }));
  };
  useEffect(() => {
    let isMounted = true;

    if (fetchedTableData?.length >= 0) {
      const mappedData = mapDataSource(fetchedTableData);
      if (isMounted) {
        setTableDataSource(mappedData);
      }
    }

    return () => {
      isMounted = false;
    };
  }, [fetchDataCount, fetchedTableData]);

  useEffect(() => {
    return () => {
      window.scrollTo(0, 0);
    };
  }, []);

  const tablePagination = useSelector(
    (store) => store.websitePackages.tablePagination
  );

  return (
    <SharedAntdTable
      scroll={1200}
      showHeader={true}
      className={`recent-clients-table ${i18n.dir()}`}
      hasPagination={true}
      tableDataSource={tableDataSource}
      tableColumns={WebsitePackagesTableColumns}
      allFetchedTableData={fetchedTableData}
      setFormModalOpened={() =>
        dispatch(setWebsitePackageFormOpenedAction(true))
      }
      // setDetailsModalOpened={setDetailsModalOpened}
      //
      deleteModalOpened={deleteModalOpened}
      setDeleteModalOpened={(v) => dispatch(setDeleteModalOpened(v))}
      setSelectedTableRow={(v) => dispatch(setSelectedTableRow(v))}
      //
      setConfirmModal={(v) => dispatch(setConfirmModal(v))}
      isLoadingTableData={isLoadingTableData}
      user={user}
      tablePagination={tablePagination}
      baseTablePageUrl={`${
        sharedRouterLinks?.websitePackagesRoute
      }?searchText=${values?.searchText || ''}&sort=${values?.sort || ''}`}
    />
  );
};

export default WebsitePackagesPageTable;
